export default function PHP_Slicing_Strings() {
  return (
    <div>
      <h1>PHP_Slicing_Strings</h1>
    </div>
  );
}
